import React from 'react';
import styled from 'styled-components';
import { MatchScore } from 'app/components/match/matchDetailHeader/MatchDetailHeaderStyles';
import { COLORS, Typography } from '@fupa/fupa-uikit';
const Container = styled(MatchScore).withConfig({
  componentId: "sc-1rqtdjj-0"
})(["&&&{letter-spacing:normal;}"]);
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-1rqtdjj-1"
})(["&&&{color:", ";}"], COLORS.black);
const MatchStatusDisplay = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "MatchStatusDisplay",
    "data-sentry-source-file": "MatchStatusDisplay.tsx"
  }, /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "StyledTypography",
    "data-sentry-source-file": "MatchStatusDisplay.tsx"
  }, text));
};
export default MatchStatusDisplay;